import React from 'react'
import { Outlet } from 'react-router-dom'
import Header from '../includes/Header'
import Footer from '../includes/Footer'
import LanguageSelector from '../../component/LanguageSelector'

export default function AppLayout() {
  return (
    <div className="app">
      <Header />
      <main className="content">
        <Outlet />
      </main>
      <Footer />
      <LanguageSelector />
    </div>
  )
}
